<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "CarrierIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
